export const categories = [
  { id: 1, name: '恋爱', slug: 'romance', description: '甜蜜浪漫的韩国恋爱漫画' },
  { id: 2, name: '奇幻', slug: 'fantasy', description: '魔幻世界与超自然冒险' },
  { id: 3, name: '动作', slug: 'action', description: '热血刺激的战斗漫画' },
  { id: 4, name: '悬疑', slug: 'mystery', description: '扣人心弦的推理悬疑' },
  { id: 5, name: 'BL', slug: 'bl', description: '唯美动人的BL漫画' },
  { id: 6, name: '校园', slug: 'school', description: '青春活力的校园故事' },
  { id: 7, name: '搞笑', slug: 'comedy', description: '轻松愉快的搞笑漫画' },
  { id: 8, name: '古风', slug: 'historical', description: '古色古香的历史题材' },
];

export const comics = [
  {
    id: 1,
    title: '某天成为公主',
    author: 'Spoon',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20a%20princess%20in%20an%20elegant%20pink%20dress%20with%20long%20flowing%20hair%2C%20castle%20background%2C%20soft%20romantic%20lighting%2C%20delicate%20art%20style%2C%20pastel%20color%20palette%2C%20clean%20white%20background%20edges&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: 'romance',
    description: '某天醒来，我发现自己变成了小说中的公主——那个注定要被父亲处死的可怜公主。为了活下去，我必须努力赢得父皇的宠爱！一段温暖治愈的父女亲情故事就此展开。',
    status: '连载中',
    rating: 9.6,
    views: 2580000,
    updatedAt: '2026-08-03',
    chapters: [
      { num: 127, title: '第127话 - 父王的决心', date: '2026-08-03' },
      { num: 126, title: '第126话 - 深夜的对话', date: '2026-07-27' },
      { num: 125, title: '第125话 - 新的开始', date: '2026-07-20' },
      { num: 124, title: '第124话 - 不速之客', date: '2026-07-13' },
      { num: 123, title: '第123话 - 花园的秘密', date: '2026-07-06' },
      { num: 122, title: '第122话 - 重逢', date: '2026-06-29' },
      { num: 121, title: '第121话 - 月光下的约定', date: '2026-06-22' },
      { num: 120, title: '第120话 - 命运的转折', date: '2026-06-15' },
    ],
  },
  {
    id: 2,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20fantasy%20Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20male%20hunter%20with%20dark%20hair%20and%20glowing%20eyes%2C%20holding%20a%20dagger%2C%20shadow%20army%20behind%20him%2C%20dramatic%20contrast%20lighting%2C%20epic%20composition%2C%20cool%20dark%20tone%20with%20purple%20accents&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: 'action',
    description: '十年前，连接异次元的"门"突然出现，被称为"猎人"的人类觉醒了超能力。故事的主角成振宇，是一位被称为"人类最弱兵器"的E级猎人。某次在双重地下城中濒死之际，他面前出现了神秘的任务窗口。从此，只有他一个人能够"升级"的冒险开始了！',
    status: '已完结',
    rating: 9.8,
    views: 8900000,
    updatedAt: '2026-06-15',
    chapters: [
      { num: 200, title: '第200话 - 最终章（后篇）', date: '2026-06-15' },
      { num: 199, title: '第199话 - 最终章（前篇）', date: '2026-06-08' },
      { num: 198, title: '第198话 - 最后的战斗', date: '2026-06-01' },
      { num: 197, title: '第197话 - 君王降临', date: '2026-05-25' },
      { num: 196, title: '第196话 - 觉醒', date: '2026-05-18' },
    ],
  },
  {
    id: 3,
    title: '再婚皇后',
    author: 'Alpha Tart',
    cover: 'https://readdy.ai/api/search-image?query=A%20romantic%20Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20queen%20in%20a%20beautiful%20gown%20with%20intricate%20details%2C%20royal%20court%20setting%2C%20warm%20golden%20lighting%2C%20regal%20atmosphere%2C%20refined%20art%20style%2C%20soft%20focus%20background&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: 'romance',
    description: '娜维埃作为东帝国的完美皇后，却被皇帝索本修背叛——他与一名女奴厮混并令其怀孕。面对羞辱，娜维埃做出了一个大胆的决定：她要离婚，并与邻国的国王再婚！一场关于尊严与爱情的宫廷斗争大戏拉开帷幕。',
    status: '连载中',
    rating: 9.5,
    views: 4200000,
    updatedAt: '2026-08-02',
    chapters: [
      { num: 156, title: '第156话 - 新的棋局', date: '2026-08-02' },
      { num: 155, title: '第155话 - 暗中较量', date: '2026-07-26' },
      { num: 154, title: '第154话 - 访客', date: '2026-07-19' },
      { num: 153, title: '第153话 - 边境风云', date: '2026-07-12' },
    ],
  },
  {
    id: 4,
    title: '全知读者视角',
    author: 'sing N song / Sleepy-C',
    cover: 'https://readdy.ai/api/search-image?query=A%20surreal%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20in%20a%20subway%20train%20with%20apocalyptic%20scenes%20outside%2C%20document%20fragments%20floating%20around%2C%20mysterious%20atmosphere%2C%20cool%20blue%20and%20white%20tone%2C%20dynamic%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: 'fantasy',
    description: '金独子是一个普通上班族，唯一的爱好是阅读一部连载了十年的网文小说。当小说终于完结的那天，书中的世界突然变成了现实——而他，是唯一知道这个世界结局的人。凭借对剧情的全知全能，金独子踏上了改变世界命运的旅程。',
    status: '连载中',
    rating: 9.7,
    views: 5600000,
    updatedAt: '2026-08-01',
    chapters: [
      { num: 188, title: '第188话 - 恶魔之王', date: '2026-08-01' },
      { num: 187, title: '第187话 - 新星', date: '2026-07-25' },
      { num: 186, title: '第186话 - 商议', date: '2026-07-18' },
      { num: 185, title: '第185话 - 地狱之旅', date: '2026-07-11' },
    ],
  },
  {
    id: 5,
    title: '恶役只有死亡结局',
    author: 'Gwon Gyeoeul / SUOL',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20style%20illustration%20of%20a%20noblewoman%20with%20pink%20hair%20in%20a%20lavish%20dress%2C%20holding%20a%20rose%2C%20dark%20castle%20interior%2C%20gothic%20atmosphere%2C%20contrast%20between%20beauty%20and%20darkness%2C%20intricate%20details&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: 'romance',
    description: '穿越到一款乙女游戏中，却成为了那个注定死于非命的恶役千金——佩内洛普·埃卡特。更糟糕的是，游戏变成了"硬核模式"，每一个选择都可能导向死亡。为了生存，她必须攻略那些憎恨她的男主角们。',
    status: '连载中',
    rating: 9.4,
    views: 3800000,
    updatedAt: '2026-07-31',
    chapters: [
      { num: 142, title: '第142话 - 真相', date: '2026-07-31' },
      { num: 141, title: '第141话 - 裂痕', date: '2026-07-24' },
      { num: 140, title: '第140话 - 试探', date: '2026-07-17' },
    ],
  },
  {
    id: 6,
    title: '世子消失了',
    author: 'Jin Soye / STUDIO JBB',
    cover: 'https://readdy.ai/api/search-image?query=A%20historical%20Korean%20manhwa%20style%20illustration%20of%20a%20crown%20prince%20in%20traditional%20hanbok%20standing%20in%20an%20ancient%20palace%20courtyard%2C%20moonlight%2C%20mysterious%20and%20romantic%20atmosphere%2C%20soft%20brushstroke%20art%20style%2C%20warm%20amber%20and%20gold%20tones&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: 'historical',
    description: '朝鲜时代的王世子突然神秘失踪，宫廷上下乱作一团。为了掩盖真相，不得不找了一个替身假扮世子。而这个替身，竟然是世子妃身边的小宫女！一场关于身份、权力与爱情的古装宫廷故事。',
    status: '连载中',
    rating: 9.3,
    views: 1950000,
    updatedAt: '2026-08-02',
    chapters: [
      { num: 93, title: '第93话 - 危机', date: '2026-08-02' },
      { num: 92, title: '第92话 - 密信', date: '2026-07-26' },
      { num: 91, title: '第91话 - 夜访', date: '2026-07-19' },
    ],
  },
  {
    id: 7,
    title: '剑尊归来',
    author: 'Yuun / Ratana',
    cover: 'https://readdy.ai/api/search-image?query=A%20martial%20arts%20Korean%20manhwa%20style%20illustration%20of%20a%20swordsman%20with%20long%20white%20hair%20holding%20a%20glowing%20sword%2C%20mountain%20peak%20background%20with%20mist%2C%20epic%20oriental%20fantasy%20style%2C%20dramatic%20lighting%2C%20flowing%20robes%2C%20powerful%20aura&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: 'action',
    description: '一代剑尊在魔教围攻中陨落，百年后却在一个落魄门派少年身上重生。带着前世的记忆与剑术，他要重振门派威名，向那些曾经背叛他的人复仇！绝妙的剑术对决与江湖恩怨就此展开。',
    status: '连载中',
    rating: 9.2,
    views: 3100000,
    updatedAt: '2026-08-03',
    chapters: [
      { num: 108, title: '第108话 - 剑意', date: '2026-08-03' },
      { num: 107, title: '第107话 - 对决', date: '2026-07-27' },
      { num: 106, title: '第106话 - 旧敌', date: '2026-07-20' },
    ],
  },
  {
    id: 8,
    title: '女神降临',
    author: 'Yaongyi',
    cover: 'https://readdy.ai/api/search-image?query=A%20school%20life%20Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20high%20school%20girl%20with%20long%20hair%20and%20perfect%20makeup%2C%20school%20hallway%20background%2C%20bright%20and%20cheerful%20atmosphere%2C%20modern%20Korean%20youth%20style%2C%20popular%20campus%20vibe&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: 'school',
    description: '林周京因为长相平凡在学校饱受欺凌，于是她通过观看美妆视频学会了化妆技巧。转学后，她以完美妆容化身"女神"，开始了截然不同的校园生活。但她最大的秘密——素颜，却随时可能被揭穿！',
    status: '已完结',
    rating: 9.1,
    views: 7200000,
    updatedAt: '2026-04-20',
    chapters: [
      { num: 250, title: '第250话 - 最终话', date: '2026-04-20' },
      { num: 249, title: '第249话 - 告白', date: '2026-04-13' },
      { num: 248, title: '第248话 - 抉择', date: '2026-04-06' },
    ],
  },
  {
    id: 9,
    title: '杀死恶女',
    author: 'Gi Eon / Jari',
    cover: 'https://readdy.ai/api/search-image?query=A%20dramatic%20Korean%20manhwa%20style%20illustration%20of%20a%20noblewoman%20with%20dark%20hair%20holding%20a%20dagger%2C%20blood%20on%20her%20hands%2C%20dark%20palace%20background%2C%20intense%20and%20tragic%20mood%2C%20gothic%20romance%20style%2C%20red%20and%20black%20color%20scheme&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: 'romance',
    description: '被心爱之人亲手杀害后，艾丽丝回到了一切悲剧发生之前。这一次，她不再做那个任人宰割的善良女子。"既然你们都想要一个恶女，那我就成为真正的恶女。"复仇的烈焰开始燃烧。',
    status: '连载中',
    rating: 9.5,
    views: 2950000,
    updatedAt: '2026-08-01',
    chapters: [
      { num: 88, title: '第88话 - 审判', date: '2026-08-01' },
      { num: 87, title: '第87话 - 报复', date: '2026-07-25' },
      { num: 86, title: '第86话 - 暗流', date: '2026-07-18' },
    ],
  },
  {
    id: 10,
    title: '入学档案',
    author: 'HEO Suyeong / RYU',
    cover: 'https://readdy.ai/api/search-image?query=A%20mystery%20Korean%20manhwa%20style%20illustration%20of%20students%20in%20a%20dark%20school%20hallway%20with%20suspicious%20expressions%2C%20eerie%20atmosphere%2C%20lockers%20and%20classroom%20doors%2C%20thriller%20mood%2C%20muted%20colors%20with%20red%20accents&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: 'mystery',
    description: '转学到精英高中第一天，主角就感受到了这所学校不寻常的氛围。同学们看似友善，却都隐藏着不为人知的秘密。而在学校的入学档案室中，她发现了一个惊天秘密——这里的学生都在参加一场致命的"游戏"。',
    status: '连载中',
    rating: 9.0,
    views: 1680000,
    updatedAt: '2026-08-02',
    chapters: [
      { num: 67, title: '第67话 - 档案室的秘密', date: '2026-08-02' },
      { num: 66, title: '第66话 - 地下通道', date: '2026-07-26' },
      { num: 65, title: '第65话 - 追查', date: '2026-07-19' },
      { num: 64, title: '第64话 - 新线索', date: '2026-07-12' },
    ],
  },
  {
    id: 11,
    title: '笑面人',
    author: 'Jung Seo / LICO',
    cover: 'https://readdy.ai/api/search-image?query=A%20comedy%20Korean%20manhwa%20style%20illustration%20of%20a%20funny%20male%20student%20with%20exaggerated%20facial%20expression%2C%20school%20setting%2C%20bright%20and%20colorful%20art%20style%2C%20chibi%20style%20elements%2C%20energetic%20and%20humorous%20vibe&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: 'comedy',
    description: '金秀赫天生一副凶神恶煞的面孔，却有着一颗最温柔的心。转学到新学校后，因为长相被所有人惧怕，但他决心要用行动证明自己！一部让人笑到停不下来的校园搞笑漫画。',
    status: '连载中',
    rating: 9.2,
    views: 2450000,
    updatedAt: '2026-08-03',
    chapters: [
      { num: 115, title: '第115话 - 误会', date: '2026-08-03' },
      { num: 114, title: '第114话 - 真心', date: '2026-07-27' },
      { num: 113, title: '第113话 - 友情', date: '2026-07-20' },
    ],
  },
  {
    id: 12,
    title: '语义错误',
    author: 'Jeosuri / Angy',
    cover: 'https://readdy.ai/api/search-image?query=A%20BL%20romance%20Korean%20manhwa%20style%20illustration%20of%20two%20male%20college%20students%20standing%20close%20together%2C%20one%20serious%20and%20one%20playful%2C%20university%20campus%20background%2C%20warm%20spring%20lighting%2C%20tender%20atmosphere%2C%20modern%20Korean%20style&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: 'bl',
    description: '秋尚宇是计算机系的天才学霸，生活规律得像一行行代码。而张载烈是设计系的自由灵魂，总是打破他的规则。两个性格截然相反的人在被迫合作完成项目时，发生了一系列令人心动的化学反应。',
    status: '已完结',
    rating: 9.6,
    views: 4100000,
    updatedAt: '2026-03-10',
    chapters: [
      { num: 93, title: '第93话 - 最终话', date: '2026-03-10' },
      { num: 92, title: '第92话 - 约定', date: '2026-03-03' },
      { num: 91, title: '第91话 - 勇气', date: '2026-02-24' },
    ],
  },
];

export const faqs = [
  {
    question: '韩国漫画网上的漫画是免费的吗？',
    answer: '是的，韩国漫画网上的所有漫画内容均为免费阅读。我们致力于为广大韩漫爱好者提供免费的漫画阅读服务，无需支付任何费用即可畅享海量韩漫资源。',
  },
  {
    question: '如何在韩国漫画网上搜索想看的漫画？',
    answer: '您可以通过首页的搜索功能输入漫画名称或作者名进行搜索，也可以浏览各个分类页面按类型查找。我们的分类包括恋爱、奇幻、动作、悬疑、BL、校园、搞笑和古风等，方便您快速定位感兴趣的漫画类型。',
  },
  {
    question: '韩国漫画网多久更新一次？',
    answer: '我们与韩国各大漫画平台保持同步更新，大部分热门连载漫画每周更新1话。您可以收藏喜欢的漫画，更新时我们会第一时间通知您，确保不会错过任何精彩内容。',
  },
  {
    question: '什么是下拉式漫画阅读？',
    answer: '下拉式漫画是为手机和电脑阅读优化的垂直阅读方式。与传统的翻页漫画不同，下拉式漫画所有内容在一列垂直排列，您只需向下滑动即可连续阅读，无需翻页，阅读体验更加流畅自然。',
  },
  {
    question: '网站支持手机阅读吗？',
    answer: '韩国漫画网采用响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用哪种设备访问，都能获得最佳的阅读体验。在手机上阅读时，我们的下拉式布局尤其舒适便捷。',
  },
  {
    question: '如何联系韩国漫画网的客服？',
    answer: '您可以通过我们"关于我们"页面中的联系方式与我们取得联系。我们提供电子邮件支持和在线留言服务，工作日内我们会在24小时内回复您的咨询。如果您有漫画推荐或版权相关问题，也欢迎随时联系我们。',
  },
];

export const siteInfo = {
  name: '韩国漫画网',
  tagline: '韩漫大全 - 下拉式漫画全集在线阅读',
  description: '韩国漫画网是领先的中文韩漫在线阅读平台，提供韩国免费漫画、韩漫大全、下拉式漫画全集在线浏览，资源丰富，更新迅速，分类清晰。',
  email: 'contact@koreancomic.cn',
  address: '北京市朝阳区望京SOHO T3-A座 2508室',
  phone: '400-888-6688',
  socialLinks: {
    weibo: 'https://weibo.com',
    wechat: '#',
    bilibili: 'https://bilibili.com',
  },
};